// @ts-nocheck
import { IconMapPin, IconCalendarEvent } from '@tabler/icons-react';
import Time from '@/utils/time';
import styles from './CustomerZoneHome.module.css';
import { deriveStatusTone, getJobAppointment, MiniCard, MiniRow } from './CustomerZoneShared';

interface Props {
  jobs: any[];
  now: any;
  base: string;
  nav: (path: string) => void;
  limit?: number;
}

export default function CustomerZoneJobsTab({ jobs, now, base, nav, limit }: Props) {
  if (!jobs.length) return <p className={styles.emptyNote}>There are no jobs</p>;

  const items = limit ? jobs.slice(0, limit) : jobs;
  return items.map((job, i) => {
    const appt = getJobAppointment(job, now);
    const statusText = job.JobCardStatusDescription || (job._closed ? 'Closed' : 'Open');
    return (
      <MiniCard
        key={i}
        href={`/customerzone/viewjob${base}&i=${job.ID}`}
        title={job.JobCardNumber}
        tone={job._closed ? 'ok' : deriveStatusTone(statusText)}
        statusText={statusText}
        onClick={() => nav(`/customerzone/viewjob${base}&i=${job.ID}`)}
        rows={<>
          {job.Location?.AddressLine1 && (
            <MiniRow icon={<IconMapPin />}>{job.Location.AddressLine1}</MiniRow>
          )}
          {appt && (
            <MiniRow icon={<IconCalendarEvent />}>
              {Time.toISOString(Time.parseDate(appt.StartDateTime), false, true, false)}
            </MiniRow>
          )}
        </>}
      />
    );
  });
}
